import {Button, ButtonProps} from "@mui/material";

export default function BasicButton(props: ButtonProps) {
    return (
        <Button
            {...props}
            disableRipple
            style={{
                borderRadius: 6,
                gap: 12,
                minWidth: 124,
                minHeight: 40,
                ...props.style,
            }}
        />
    );
}
